import { useEffect, useState } from "react";
import Services from "../../utils/services";

const SuggestionAI = (props) => {
    const [searchKeyword, setSearchKeyword] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [fieldedSuggestions, setFieldedSuggestions] = useState([]);
    const [keyEventName, setKeyEventName] = useState('');
    const [isResultPage, setIsResultPage] = useState(false);
    const [cursor, setCursor] = useState(-1);

    useEffect(() => {
        if (props.searchKeyword !== searchKeyword) {
            setSearchKeyword(props.searchKeyword)
            getSuggestionsList(props.searchKeyword)
        }
        if (props.keyBoardEvent) {
            if (props.keyEventName !== keyEventName) {
                setKeyEventName(props.keyEventName);
                handleKeyDown();
                props.setKeyBoardEvent()
            }
        }
    }, [props.searchKeyword, props.keyBoardEvent])

    useEffect(() => {
        if (props.isFromResultPage) {
            setIsResultPage(true)
        }
    }, [])

    const getSuggestionsList = async (keyword) => {
        let services = new Services();
        if (props.searchKeyword.length > 0) {
            let res = await services.getSuggestions(keyword)
            if (res.data) {
                setSuggestions(res.data.dictionarySuggestions)
                setFieldedSuggestions(res.data.fieldSuggestions)
            }
        }
    }
    const listOfSuggestions = (arr) => {
        //console.log(arr);
        if (arr.length > 0) {
            return (
                arr.map((item, index) => {
                    if (item) {
                        return (
                            <li key={index} onClick={e => setSearchKeywordFromSuggestion(item)} className={cursor === index ? 'suggestions-list-active' : ''}
                                style={{ paddingLeft: (isResultPage) && '1.5rem' }}
                                onMouseEnter={e => handleOnEnter}>{convertToHtml(item)}</li>
                        )
                    }
                })
            )
        }
    }
    const convertToHtml = (item) => {
        return (<div dangerouslySetInnerHTML={{ __html: item }}></div>)
    }
    const setSearchKeywordFromSuggestion = (item) => {
        let fieldedValue, query;
        //console.log(item)
        let keyword = item.replaceAll('<b>', '').replaceAll('</b>', '');
        if (keyword.lastIndexOf(' in all ') > 0) {
            //console.log(keyword)
            let indexofField = keyword.lastIndexOf('in all');
            fieldedValue = keyword.substring(indexofField + 7, keyword.length);
            query = keyword.substring(0, indexofField - 1);
            /* fieldedValue = keyword.split(' in all ')[1]
            query = keyword.split(' in all ')[0] */
            setSearchKeyword(keyword)
            props.handleOnChange(query, fieldedValue)
            //props.handleOnSuggestionClick(true);
        }
        else {
            query = keyword
            props.handleOnChange(query, null);
        }
    }
    const handleOnEnter = (e) => {
        if (['Enter'].includes(e.key)) {
            //console.log(e.target.value)
            setSearchKeywordFromSuggestion(suggestions[cursor])
        }
    }
    const handleKeyDown = (e) => {
        //console.log(e)

        if (e === 'ArrowUp' && cursor > 0) {
            setCursor(prevState => prevState.cursor - 1)
            setSearchKeywordFromSuggestion(suggestions[cursor - 1])
            /*setCursor(prevState => ({
                cursor: prevState.cursor - 1
            }), () => {
                setSearchKeywordFromSuggestion(suggestions[this.state.cursor])
            })*/
        } else if (e === 'ArrowDown' && cursor < suggestions.length - 1) {
            setCursor(prevState => prevState.cursor - 1)
            setSearchKeywordFromSuggestion(suggestions[cursor - 1])
            /*this.setState(prevState => ({
                cursor: prevState.cursor + 1
            }), () => {
                setSearchKeywordFromSuggestion(suggestions[this.state.cursor])
            })*/
        }
        //console.log(e);
    }
    return (<>
        {props.showSuggestions && (suggestions.length > 0 || fieldedSuggestions.length > 0) &&
            <div className={(isResultPage) ? "suggestions-list-wrapper-AI result-sugg" : "suggestions-list-wrapper-AI"}>
                {suggestions.length > 0 || fieldedSuggestions.length > 0 ?
                    <ul>
                        {listOfSuggestions(suggestions)}
                        {suggestions.length > 0 && fieldedSuggestions.length > 0
                            // &&
                            // <hr/>
                        }
                        {fieldedSuggestions.length > 0 &&
                            <>
                                <div className="suggestions-fielded-header" style={{ paddingLeft: (isResultPage) ? '1.5rem' : '3.5rem', color: '#EB1007' }}>Are you looking for..</div>
                                {listOfSuggestions(fieldedSuggestions)}
                            </>
                        }
                    </ul>
                    :
                    <></>
                }
            </div>
        }</>)
}
export default SuggestionAI;